module.exports = __webpack_public_path__ + "static/media/benji.9e090a40.jpg";